<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="导入"
      width="400px"
      :show-close="true"
      :visible="true"
      :before-close="handleBeforeClose"
      :modal="modal"
    >
      <p class="dialog_content_text">
        <i class="iconfont icontishi"></i>
        <span>{{ uploadMessage }}</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="isUploading"
          size="mini"
          type="info"
          plain
          @click="handlerDownloadTemplate"
          >下载模版</el-button
        >
        <el-button
          :disabled="isUploading"
          type="primary"
          size="mini"
          @click="handlerUploadFile"
          >上传文件</el-button
        >
        <input
          type="file"
          @change="handlerFileSelect"
          style="display: none"
          ref="uploadInput"
        />
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="导入提示"
      width="400px"
      :show-close="true"
      :visible="showPrompt"
      :before-close="handleBeforeClosePrompt"
      :modal="modal"
    >
      <div>
        <p>
          本次成功导入数据{{ prompt.successCount }}条，导入失败{{
            prompt.failureCount
          }}
        </p>
        <p>导入失败的数据行数有：{{ prompt.failureListStr }}</p>
        <ul v-if="prompt.failureReason.length" class="prompt-box">
          <li v-for="(item, index) in prompt.failureReason" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import  { checkOperateStatus } from '@/api/StaffRoster'
export default {
  data() {
    return {
      uploadMessage: "请下载模版进行导入，文件大小限制在10M以内！",
      isUploading: false,
      showPrompt: false,
      prompt: {
        failureLines: [],
        failureReason: [],
      },
    };
  },
  props: {
    // 导入的方法
    importFun: {
      type: Function,
      required: true,
    },
    // 导入的参数
    importParams: {
      type: Object,
      required: false,
      default: () => {},
    },
    // 下载模板的方法
    downFun: {
      type: Function,
      required: true,
    },
    uploadDialog: {
      type: Boolean,
      default: false,
    },
    excelType: {
      type: String,
      required: false,
    },
    downParams: {
      require: false,
    },
    modal: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    // 导入
    handlerFileSelect() {
      if (this.$refs.uploadInput.files && this.$refs.uploadInput.files.length) {
        let formData = new FormData();
        formData.append("fileData", this.$refs.uploadInput.files[0]);
        this.isUploading = true;
        this.uploadMessage = "正在导入中……";
        this.importFun(formData, this.importParams).then((res) => {
          // let failureLines = null;
          // if (this.excelType) {
          //   if (this.excelType == "notStaff") {
          //     this.showDetail(res.data, true);
          //   } else {
          //     const timmer = setInterval(async () => {
          //       const status = await checkOperateStatus({
          //         fileOperateId: res.data,
          //         fileOperateType: 1,
          //       });
          //       if (status.data.status === 2) {
          //         clearInterval(timmer);
          //         this.showDetail(status.data.resultInfo, true);
          //       }
          //       if (status.data.status === 0) {
          //         this.uploadMessage = "导入失败， 请重试！";
          //         this.isUploading = false;
          //         return;
          //         clearInterval(timmer);
          //       }
          //     }, 2000);
          //   }
          // } else {
          //   if (!(res.code != 200)) {
          //     this.uploadMessage = "导入失败， 请重试！";
          //     this.isUploading = false;
          //     return;
          //   }
          //   this.showDetail(res.data);
          // }
          if (res.code === 200) {
            this.$message.success("导入成功");
            this.$emit("uploadFinish")
          } else {
            this.$message.success("导入失败");
            this.$emit("cancel")
          }
        });
      }
    },
    showDetail(value, showDetail = false) {
      let failureLines = value.failureList.toString();
      failureLines.replace(/,/g, "、");
      let textMess = `<p>本次成功导入数据${value.successCount}条，导入失败${value.failureCount}</p>`;
      if (failureLines) {
        textMess += `<p>导入失败的数据行数有：${failureLines}</p>`;
      }
      if (showDetail) {
        this.prompt = value;
        this.prompt.failureListStr = value.failureList.toString();
        this.showPrompt = true;
        return;
      }
      this.isUploading = false;
      this.$confirm(textMess, "导入提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.uploadMessage = "请下载模版进行导入，文件大小限制在10M以内！";
          this.$emit("uploadFinish");
        })
        .catch(() => {
          this.uploadMessage = "请下载模版进行导入，文件大小限制在10M以内！";
          this.$emit("uploadFinish");
        });
    },
    // 下载模板
    handlerDownloadTemplate() {
      if (this.downParams) {
        this.downFun(this.downParams);
        return;
      }
      if (this.excelType) {
        this.downFun({ excelType: this.excelType });
        return;
      }
      this.downFun();
    },
    // 上传文件
    handlerUploadFile() {
      this.$refs.uploadInput.value = "";
      this.$refs.uploadInput.click();
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleBeforeClosePrompt(done) {
      this.showPrompt = false;
      this.$emit("uploadFinish");
      done();
    },
  },
};
</script>

<style lang="scss">
.prompt-box {
  max-height: 200px;
  overflow-y: auto;
}
.dialog_content_text {
  font-size: 12px;
  height: 60px;
  font-weight: 400;
  color: rgba(50, 60, 80, 1);
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: 40px;
    margin-right: 12px;
    color: #ffbe14;
  }
  span {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ImportDialog/ImportDialog.vue